import { FunctionComponent } from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Tooltip } from '@mui/material';

import { cn } from '../../utilities/cn';

interface PanelResizeHandleProps {
  /** Spread from `useResizablePanel`. */
  separatorProps: React.ComponentPropsWithoutRef<'div'>;
  isResizing: boolean;
  label?: string;
}

/** Vertical drag handle for a resizable split, used with `useResizablePanel`. */
export const PanelResizeHandle: FunctionComponent<PanelResizeHandleProps> = ({
  separatorProps,
  isResizing,
  label = 'Drag to resize · double-click to reset',
}) => (
  <Tooltip title={label} placement="right" arrow disableHoverListener={isResizing}>
    <div
      {...separatorProps}
      className={cn(
        'group relative flex w-2.5 shrink-0 cursor-col-resize touch-none items-center justify-center rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-mainblue',
        isResizing && 'bg-mainblue/10',
      )}
    >
      <span
        className={cn(
          'absolute inset-y-0 left-1/2 w-px -translate-x-1/2 transition-colors',
          isResizing ? 'bg-mainblue' : 'bg-gray-300 group-hover:bg-mainblue/60',
        )}
      />
      <DragIndicatorIcon
        className={cn(
          'relative z-10 rounded bg-white text-gray-400 shadow-sm ring-1 ring-gray-200 transition-colors',
          isResizing ? 'text-mainblue' : 'group-hover:text-mainblue',
        )}
        style={{ fontSize: 16 }}
      />
    </div>
  </Tooltip>
);

export default PanelResizeHandle;
